$(".video_wr .video-play-btn").click(function (e) {
     var videoItem =  $(this).closest('.video_wr').find('video');
     var videoParent =  $(this).parent();

     var otherVideoWrapper = $('.video_wr');
     otherVideoWrapper.not(videoParent).removeClass('play');
  
     var otherVideo = $('.video_wr video');
     otherVideo.not(videoItem).get(0).pause();

     videoParent.addClass('play');
     videoItem.get(0).play();

    e.preventDefault();
});

$(".video_wr .video-pause-btn").click(function (e) {
     var video =  $(this).closest('.video_wr').find('video');
    video.get(0).pause();
    $(this).closest('.video_wr').removeClass('play');
    e.preventDefault();
});